import { render, staticRenderFns } from "./person-detailed-form.vue?vue&type=template&id=0a8d3844&"
import script from "./person-detailed-form.vue?vue&type=script&lang=js&"
export * from "./person-detailed-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports